import { LitElement, html } from "lit-element";
import { SharedStyles } from "../../styles/shared-styles";
import { chevronLeft, chevronRight } from "../../styles/icons.js";

export class InspxDrawingMainToolbar extends LitElement {
	render() {
		if (this.getColor) {
			this.style.setProperty("--selected-color", this.getColor());
		}
		let expClass = this.isCollapsed ? "" : "item-expanded";

		return html`
            ${SharedStyles}
            <style>
                input[type="radio"] {
                    display: none;
                    --selected-color: gray;
                }

                .main-toolbar {
                    height: 100%;
                    width: 50px;
                    background-color: var(--secondary-color);
                    color: var( --primary-color-variant1);
                    fill: var(--primary-color-variant1);
                    text-align: center;
                    overflow-y: auto;
                }

                .main-toolbar .icon {
                    padding-top: 5px;
                    width: 50px;
                }

                .item {
                    cursor: pointer;
                    display: flex;
                    flex-direction: row;
                }

                .color{
                    fill: var(--selected-color, inherit);       
                }

                .item[selected]{
                    background-color: var(--primary-color);
                }
                
                .main-toolbar-text {
                    display: none;
                }

                .main-toolbar-expanded {
                    width: 200px;
                }

                .item-expanded .main-toolbar-text {
                    display: block;
                    font-size: 14px;
                    text-align: left;
                    margin: auto 10px;
                    height: inherit;
                    text-transform: capitalize;
                }

                .expand {
                    margin: 5px 0px;
                }

                .item-expanded.expand {
                    justify-content: flex-end;
                }
            </style>

            <div class="main-toolbar ${this.isCollapsed ? "" : "main-toolbar-expanded"}" id='main-tb'>
                <label class='item expand ${expClass}' @click="${e => this._expandCollapseToolbar(e)}">
                    <div class="icon">${this.isCollapsed ? chevronRight : chevronLeft}</div>
                </label>
                ${this.modules.map(i => this._renderItem(i, expClass))}
            </div>`;
	}

	_renderItem(i, expClass) {
		return html`
            <label name='${i.MainTb.value}' class='item ${i.MainTb.value} ${expClass}' 
                @click="${e => this.__selectModule(e.currentTarget, i)}">
                <div class="icon">${i.MainTb.icon}</div>
                <div class="main-toolbar-text">${i.MainTb.text}</div>
            </label>`;
	}

	activateModule(m) {
		let name = m.MainTb.value;
		var element = this.shadowRoot.querySelector("label[name='" + name + "']");
		this.__selectModule(element, m);
	}

	__selectModule(target, e) {
		for (let element of target.parentElement.children) {
			element.removeAttribute("selected");
		}

		target.setAttribute("selected", "selected");

		if (this.onSelected) {
			this.onSelected({
				current: this.selected,
				next: e
			});
		}

		this.selected = e;
	}

	_expandCollapseToolbar() {
		this.isCollapsed = !this.isCollapsed;
	}

	firstUpdated() {
		this.activateModule(this.modules[this.defaultModuleIndex]);
	}

	static get properties() {
		return {
			modules: Array,
			isCollapsed: Boolean
		};
	}

	constructor(modules, colorSelector, defaultModuleIndex) {
		super();
		this.isCollapsed = true;
		this.getColor = colorSelector;
		this.modules = modules;
		this.defaultModuleIndex = defaultModuleIndex || 0;
	}
}

window.customElements.define(
	"inspx-drawing-main-toolbar",
	InspxDrawingMainToolbar
);
